import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';

import AddIconImage from '../../shared/svg/plus.svg';
import CompletedIconImage from '../../shared/svg/check.svg';

import ImageCard from '../../components/ImageCard';

import './index.scss';
import ListPage from '../../layouts/ListPage';

function CBAMenu() {

  const profileCompletionChecks = [
    {
      title: 'Articles',
      description: ``,
      completed: true,
      uri: '/articles'
    },
    {
      title: 'Authors',
      description: ``,
      completed: true,
      uri: '/authors'
    },
  ];

  return (
    <ListPage
      title={'Canada Beef Advantage'}
      description={'View and manage articles and authors.'}
      breadcrumbsLinks={[
        {
          url: '/',
          content: 'Content Library',
        },
      ]}
    >
      <Box className="check-icon" sx={{ flexGrow: 1 }}>
        <Grid container spacing={2}>
          {profileCompletionChecks.map((check) => (
            <Grid key={check.title} item xs={6} md={4} lg={3} xl={2}>
              <ImageCard
                url={check.uri}
                item={{
                  title: check.title,
                  description: check.description,
                  url: check.completed ? CompletedIconImage : AddIconImage
                }}
                icon={true}
                imageBackground='#fff'
              />
            </Grid>
          ))}
        </Grid>
      </Box>
    </ListPage>
  )
}

export default CBAMenu;